import { qs } from '../core/utils';

export const initNavigation = (): void => {
  const toggle = qs('.nav__toggle');
  const links = qs('.nav__links');

  toggle?.addEventListener('click', () => {
    const isOpen = links?.classList.contains('is-open');
    links?.classList.toggle('is-open', !isOpen);
    toggle.setAttribute('aria-expanded', String(!isOpen));
  });

  links?.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      links.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
    }
  });

  const sections = document.querySelectorAll('section[id]');
  const navItems = document.querySelectorAll('.nav__links a');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');
          navItems.forEach((item) => {
            item.classList.toggle('is-active', item.getAttribute('href') === `#${id}`);
          });
        }
      });
    },
    { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
  );

  sections.forEach((section) => observer.observe(section));
};
